import script from "./MenuItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemModal.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemModal.vue?vue&type=style&index=0&id=077ea2d5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-077ea2d5"]])

export default __exports__